import React, { Component } from 'react';
import { Container } from 'reactstrap';

// import images
import frederick from '../../assets/images/team/frederick.jpeg';
import grace from '../../assets/images/team/grace.jpeg';
import kelvin from '../../assets/images/team/kelvin.jpeg';
import raphael from '../../assets/images/team/raphael.jpeg';
import mary from '../../assets/images/team/mary.jpeg';

import SectionTitle from '../../components/Shared/SectionTitle';
import TeamBox from '../../components/Shared/TeamBox';

export default class Team extends Component {
  constructor(props) {
    super(props);
    this.state = {
      team: [
        {
          name: 'Frederick Karanja Mwangi',
          image: frederick,
          designation: 'Managing Director',
        },
        {
          name: 'Raphael Njau',
          image: raphael,
          designation: 'General Manager',
        },
        {
          name: 'Kelvin Kamenju',
          image: kelvin,
          designation: 'Head of Recruitment',
        },
        {
          name: 'Grace Wambui Thumbi',
          image: grace,
          designation: 'Receptionist',
        },
        {
          name: 'Mary Kimani',
          image: mary,
          designation: 'International Relation',
        },
      ],
    };
  }

  render() {
    return (
      <React.Fragment>
        <Container className={''}>
          <SectionTitle
            title="Our Team"
            desc=""
          />
          <TeamBox candidates={this.state.team} isCenter={true} />
        </Container>
      </React.Fragment>
    );
  }
}
